// extracted by mini-css-extract-plugin
export var labelWrapper = "_fm-0";